import { Package } from '@features/DynamicPackagesConfigurationWizard/types';

export const fitsPackageStayLength = (
  packageData: Pick<Package, 'numberOfNights'> | null | undefined,
  stayNights: number
): boolean =>
  !packageData || packageData.numberOfNights === 1 || packageData.numberOfNights === stayNights;
